import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import { config } from "_/config/config";
import _ from "lodash";
export default {
    /**
     * Set the component's data storage
     *
     * @return  {void}
     */
    data: function() {
        return {
            referralId: this.$route.params.referralId,
            credentials: {},
            error: null,
            disabled: false,
            step: 1,
        };
    },

    /**
     * Set the computed variables
     *
     * @type  {object}
     */
    computed: {
        ...mapGetters({
            ui: "ui/ui",
            user: "user/user",
        }),
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        ...mapActions("ui", [
            // Map actions from ui module namespace
            "setBodyClass",
            "setTitle",
        ]),

        submitForm() {
            switch (this.step) {
                case 1:
                    this.getOneTimePin();
                    break;
                case 2:
                    this.loginNewUser();
                    break;
            }
        },

        async getOneTimePin() {
            this.disabled = true;
            this.error = null;
            const params = new URLSearchParams();
            params.append("email", this.credentials.email);
            params.append("userIp", "192.168.0.1");
            try {
                let response = await axios({
                    url: `${config.ENV.apiBasePath}/auth/one-time-pin`,
                    method: "post",
                    cache: "no-cache",
                    json: true,
                    params,
                });
                this.step = 2;
                return response.data.message;
            } catch (error) {
                const errorMessage = _.get(
                    error,
                    "response.data.body.error_fields.email.message"
                );
                if (errorMessage) {
                    this.error = errorMessage;
                }
            } finally {
                this.disabled = false;
            }
        },

        async loginNewUser() {
            this.disabled = true;
            this.error = null;
            const params = new URLSearchParams();
            params.append("email", this.credentials.email);
            params.append("userIp", "192.168.0.1");
            params.append("pin", this.credentials.pin);
            params.append("referral", this.$route.params.referralId);

            try {
                let response = await axios({
                    url: `${config.ENV.apiBasePath}/auth/one-time-login`,
                    method: "post",
                    cache: "no-cache",
                    json: true,
                    params,
                });
                this.step = 3;
                return response.data.message;
            } catch (error) {
                const errorMessage = _.get(
                    error,
                    "response.data.body.error_fields.pin.message"
                );
                if (errorMessage) {
                    this.error = errorMessage;
                }
            } finally {
                this.disabled = false;
            }
        },
    },

    /**
     * Call a mounted hook
     *
     * @type  {function}
     * @return  void
     */
    mounted: function() {
        this.$nextTick(function() {
            this.setBodyClass("login-page");
            this.setTitle("Register");
        });
    },
};
